module.exports = __webpack_public_path__ + "img/more.43041f4f.svg";